export const UrlHandler = {
    getProvider(layer) {
        return layer?.provider?.name || "";
    },
    getCodigoArcgis(layer) {
        return layer?.codigo || "";
    },
    getBaseUrl(layer) {
        const url = layer?.provider?.url || "";
        if (url.endsWith('/')) {
            return url.slice(0, -1);
        }
        return url;
    },
    getArcgisUrl(layer) {
        const baseUrl = this.getBaseUrl(layer);
        const codigoLayer = this.getCodigoArcgis(layer);
        if (codigoLayer !== null && codigoLayer !== undefined && codigoLayer !== "") {
            return baseUrl + "/" + codigoLayer;
        }
        return baseUrl;
    },

};
